import { sortStr } from '@utils/sorting/non-ascii';
import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';
import { IPaginationResult } from './Equipment.model';

export interface IAssetLog {
  _id: string;
  newValue: string;
  oldValue: string;
  eventType: string;
  assetId: string;
  assetName: string;
  comments: string[];
  studioId: string;
  studioName: string;
  assetModel: string;
  eventName: string;
  triggeredById: string;
  triggeredBy: string;
  triggeredByAvatar: string;
  image: string;
  serial: string;
  updatedAt?: Date;
  createdAt?: Date;
}

export interface IAssetLogApiModel {
  _id: string;
  newValue: string;
  oldValue: string;
  eventType: string;
  assetId: string;
  assetName: string;
  comments: string[];
  studioId: string;
  studioName: string;
  assetModel: string;
  eventName: string;
  triggeredById: string;
  triggeredBy: string;
  triggeredByAvatar: string;
  image: string;
  serial: string;
  updatedAt?: string;
  createdAt?: string;
}

export default class AssetLog implements IAssetLog {
  public readonly _id: string;

  public readonly assetId: string;

  public readonly newValue: string;

  public readonly oldValue: string;

  public readonly eventType: string;

  public readonly assetName: string;

  public readonly comments: string[];

  public readonly studioId: string;

  public readonly studioName: string;

  public readonly assetModel: string;

  public readonly eventName: string;

  public readonly triggeredById: string;

  public readonly triggeredBy: string;

  public readonly triggeredByAvatar: string;

  public readonly image: string;

  public readonly serial: string;

  public readonly updatedAt: Date | undefined;

  public readonly createdAt: Date | undefined;

  constructor(
    _id: string,
    assetId: string,
    assetName: string,
    comments: string[],
    studioId: string,
    newValue: string,
    oldValue: string,
    eventType: string,
    studioName: string,
    assetModel: string,
    eventName: string,
    triggeredById: string,
    triggeredBy: string,
    triggeredByAvatar: string,
    image: string,
    serial: string,
    updatedAt: Date | undefined,
    createdAt: Date | undefined,
  ) {
    this._id = _id;
    this.assetId = assetId;
    this.assetName = assetName;
    this.comments = comments;
    this.studioId = studioId;
    this.newValue = newValue;
    this.oldValue = oldValue;
    this.eventType = eventType;
    this.studioName = studioName;
    this.assetModel = assetModel;
    this.eventName = eventName;
    this.triggeredById = triggeredById;
    this.triggeredBy = triggeredBy;
    this.triggeredByAvatar = triggeredByAvatar;
    this.image = image;
    this.serial = serial;
    this.updatedAt = updatedAt;
    this.createdAt = createdAt;
  }

  static fromApiModel(apiModel: IAssetLogApiModel) {
    const {
      _id,
      assetId,
      assetName,
      comments,
      studioId,
      newValue,
      oldValue,
      eventType,
      studioName,
      assetModel,
      eventName,
      triggeredById,
      triggeredBy,
      serial,
    } = apiModel;

    const updatedAt = apiModel.updatedAt
      ? new Date(Date.parse(apiModel.updatedAt))
      : undefined;
    const createdAt = apiModel.createdAt
      ? new Date(Date.parse(apiModel.createdAt))
      : undefined;
    const triggeredByAvatar = updateBeamUrl(apiModel.triggeredByAvatar);
    const image = updateBeamUrl(apiModel.image);

    return new AssetLog(
      _id,
      assetId,
      assetName,
      comments,
      studioId,
      newValue,
      oldValue,
      eventType,
      studioName,
      assetModel,
      eventName,
      triggeredById,
      triggeredBy,
      triggeredByAvatar,
      image,
      serial,
      updatedAt,
      createdAt,
    );
  }

  static arrayFromApiModel(arrayApiModel: IAssetLogApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }

  static arrayPaginatedFromApiModel(
    arrayApiModel: IPaginationResult<IAssetLogApiModel>,
  ) {
    const _array = arrayApiModel.results.map(apiModel =>
      AssetLog.fromApiModel(apiModel),
    );
    const array = Array.from(_array).sort((a, b) =>
      sortStr(a.assetName, b.assetName),
    );
    return {
      ...arrayApiModel,
      results: array,
    };
  }
}
